<template>
    <div>
        <div class="container-fluid p-0">
            <div class="row m-0">
                <div class="col-12 p-0">
                    <div class="login-card">
                        <div>
                            <div><a class="logo"><router-link to="/"><img class="img-fluid for-light"
                                            src="../assets/images/logo/logo.png" alt="logo image"></router-link></a></div>
                            <div class="login-main">
                                <form class="theme-form" @submit.prevent="">
                                    <h2 class="text-center">Sign in to account</h2>
                                    <p class="text-center">Enter your email & password to login</p>
                                    <div class="form-group">
                                        <label class="col-form-label">Email Address</label>
                                        <input v-model="email" class="form-control" type="email"
                                            placeholder="Test@gmail.com">
                                    </div>
                                    <div class="form-group">
                                        <label class="col-form-label">Password</label>
                                        <div class="form-input position-relative">
                                            <input v-model="password" :type="type" class="form-control"
                                                name="login[password]" placeholder="*********">
                                            <div class="show-hide"><span class="show" @click="showPassword"> </span></div>
                                        </div>
                                    </div>
                                    <div class="form-group mb-0">
                                        <div class="checkbox p-0">
                                            <input id="checkbox1" type="checkbox">
                                            <label class="text-muted" for="checkbox1">Remember password</label>
                                        </div><router-link to="/authentication/forgetpassword">Forgot
                                            password?</router-link>
                                        <div class="text-end mt-3">
                                            <button class="btn btn-primary btn-block w-100" type="button"
                                                @click="doLogin">Sign in </button>
                                        </div>
                                    </div>
                                    <div class="login-social-title">
                                        <h3>Or Sign in with </h3>
                                    </div>
                                    <div class="form-group">
                                        <ul class="login-social">
                                            <li><a href="https://www.facebook.com" target="_blank"><i
                                                        class="fa fa-facebook"></i></a></li>
                                            <li><a href="https://www.linkedin.com" target="_blank"><i
                                                        class="fa fa-linkedin"> </i></a></li>
                                            <li><a href="https://www.twitter.com" target="_blank"><i
                                                        class="fa fa-twitter"></i></a></li>
                                            <li><a href="https://www.instagram.com" target="_blank"><i
                                                        class="fa fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                    <p class="mt-4 mb-0 text-center">Don't have account?<router-link class="ms-2"
                                            to="/authentication/register">Create Account</router-link></p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            type: 'password',
            email: "test@admin.com",
            password: "test@123456",
        }
    },

    methods: {
        showPassword: function () {
            if (this.type === 'password') {
                this.type = 'text';
            } else {
                this.type = 'password';
            }
        },
        doLogin() {
            if (this.email === "test@admin.com" && this.password === "test@123456") {

                this.$router.replace('/');
                localStorage.setItem('user', this.email)
            } else {
                this.$toast.show('invalid email and password ', { theme: 'outline', position: 'top-right', icon: 'times', type: 'error', duration: 2000 });
            }
        },

    }
}

</script>
